<template>
  <div>
    <!-- Image Library Modal Starts -->
    <div class="modal is-active" v-if="show">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head headnewcl">
          <span class="cross-btn" @click="closeModal"><img src="/static/img/cross.svg" alt="cross"/></span>
        </header>

        <section class="modal-card-body">
          <!-- Tabs Section Starts-->
          <div class="custom-tabs">
            <div class="tabs is-boxed custom-tabs__tab-box">
              <ul class="custom-tabs__group">
                <!-- Review Invites Tab Begins -->
                <li :class="{'is-active': (selectedTab === 'headerImage')}" v-if="!showTabs.length || showTabs.includes('headerImage')">
                  <a @click="showTab('headerImage')" class="custom-tabs__link">
                    <span class="custom-tabs__text">Header image</span>
                  </a>
                </li>
                <!-- Review Invites Tab Ends -->
                <!-- Conversion Rate Tab Begins -->
                <li :class="{'is-active': (selectedTab === 'logoImage')}" v-if="!showTabs.length || showTabs.includes('logoImage')">
                  <a @click="showTab('logoImage')" class="custom-tabs__link">
                    <span class="custom-tabs__text">Logo</span>
                  </a>
                </li>
                <!-- Conversion Rate Tab Ends -->
              </ul>
            </div>
            <div class="custom-tabs__content-box">

              <div class="image-lib-file-upload-section">
                <div v-if="isFreeSubscription" class="free-image-upload">
                  <img data-v-3f0ee12d="" src="/static/img/upload-file-icon.svg" style="width: 30px; height: 30px;">
                  <p>Drop your header image or logo here or <a href="javascript:void(0)" class="link">browse an image</a></p>
                </div>
                <vue-dropzone
                  v-else
                  ref="uploadField"
                  id="dropzone"
                  :options="dropzoneOptions"
                  data-track="Upload Header Image or Logo Image"
                  :useCustomSlot=true
                  @vdropzone-file-added="uploadImage"
                  @vdropzone-error="errorHandle"
                >
                  <img src="/static/img/upload-file-icon.svg" style="width:30px; height: 30px;"/>
                  <p class="dropzone-custom-title">Drop your header image or logo here or <a class="link">browse an image</a></p>
                </vue-dropzone>
              </div>

              <!-- HEADER IMAGE TAB STARTS -->
              <div class="header-tab" v-if="selectedTab === 'headerImage'">
                <div class="image-lib-row">
                  <h6 :class="{'free-header-upload-heading': isFreeSubscription}">Your header images</h6>
                  <hr class="horizontal-row"/>
                  <template v-if="isFreeSubscription">
                    <p class="free-header-upload-row">
                      <router-link :to="`/billing/edit-plan/${subscription.name.toLowerCase()}/annum`">Upgrade</router-link>
                      your Package and instantly gain access to upload your own header image.
                    </p>
                  </template>
                  <div class="lib-images uploaded" v-else>
                    <template v-if="imageLibraryData.header.uploaded.length > 0">
                      <div
                        :class=" { 'img': true, 'img-header': true, selected: (selectedImage === img)}" @click="selectImage(img)"
                        v-for="img of imageLibraryData.header.uploaded">
                        <img :src="img.data.imageForlderUrl+img.data.fileName"/>
                      </div>
                    </template>
                    <template v-else>
                      <div class="no-img">You have not uploaded any images</div>
                    </template>
                  </div>
                </div>

                <div class="image-lib-row">
                  <h6>Use one of our header images</h6>
                  <hr class="horizontal-row"/>
                  <div class="lib-images default">

                    <template v-if="imageLibraryData.header.default.length > 0">
                      <div
                        :class=" { 'img': true, 'img-header': true, selected: (selectedImage === img)}" @click="selectImage(img)"
                        v-for="img of imageLibraryData.header.default">
                        <img :src="img.data.imageForlderUrl+img.data.fileName"/>
                      </div>
                    </template>
                    <template v-else>
                      <div>You have not uploaded any images</div>
                    </template>

                  </div>
                </div>

              </div>

              <!-- HEADER IMAGE TAB ENDS -->

              <!-- LOGO IMAGE TAB STARTS -->
              <div class="logo-tab" v-if="selectedTab === 'logoImage'">

                <div class="image-lib-row">
                  <template v-if="isFreeSubscription">
                    <p class="free-header-upload-row">
                      <router-link :to="`/billing/edit-plan/${subscription.name.toLowerCase()}/annum`">Upgrade</router-link>
                      your Package and instantly gain access to upload your own Logo.
                    </p>
                  </template>
                  <template v-else>
                    <hr class="horizontal-row"/>
                    <div class="lib-images uploaded">
                      <template v-if="imageLibraryData.logo.uploaded.length > 0">
                        <div
                          :class=" { 'img': true, 'img-logo': true, selected: (selectedImage === img)}" @click="selectImage(img)"
                          v-for="img of imageLibraryData.logo.uploaded">
                          <img :src="img.data.imageForlderUrl+img.data.fileName"/>
                        </div>
                      </template>
                      <template v-else>
                        <div class="no-img">You have not uploaded any images</div>
                      </template>
                    </div>
                  </template>
                </div>

              </div>
              <!-- LOGO IMAGE TAB ENDS -->


            </div>
          </div>
          <!-- Tabs Section Ends-->
        </section>

        <footer class="modal-card-foot delete-review-footer">
          <button class="button solid-btn dark-blue-btn" @click="useSelectedImage" :disabled="selectedImage === null">USE IMAGE</button>
          <button class="button hollow-btn delete-btn" @click="deleteSelectedImage" :disabled="(selectedImage === null || selectedImage.type !== 'UPLOADED')">DELETE IMAGE</button>
        </footer>
      </div>
    </div>
    <!-- Image Library Modal Ends -->
    <div style="display:none;opacity: 1" class="custom-preview-element"></div>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef,valid-jsdoc, no-useless-escape */
import axios from 'axios'
import vue2Dropzone from 'vue2-dropzone'
import misc from '../mixins/misc.js'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'ImageLibraryModal',
  mixins: [misc],
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      imageLibraryData: {
        header: {
          default: [],
          uploaded: []
        },
        logo: {
          default: [],
          uploaded: []
        }
      },
      selectedImage: null,
      selectedTab: 'headerImage',
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        maxFiles: 1,
        headers: {'My-Awesome-Header': 'header value'},
        autoProcessQueue: false,
        addRemoveLinks: true,
        uploadMultiple: true,
        acceptedFiles: 'image/png, image/jpeg',
        previewsContainer: '.custom-preview-element'
      },
      subscription: JSON.parse(localStorage.getItem('billingDetails'))['subscription']
    }
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    showTabs: {
      type: Array,
      default () {
        return []
      }
    },
    chosenTab: {
      type: String,
      default: 'headerImage'
    }
  },
  created () {
    this.selectedTab = this.$props.chosenTab || 'headerImage'
  },
  mounted () {
    this.getReviewInvitationMailImages()
  },
  computed: {
    isFreeSubscription () {
      return this.subscription && this.subscription.name === 'Free'
    }
  },
  methods: {
    /**
     * Get the invitation template content for preview
     * @return {void}
     */
    getReviewInvitationMailImages () {
      this.resetImageLib()
      axios.get(`/${this.businessSlug}/review/get-mail-images`)
        .then((response) => {
          response.data.data.forEach(img => {
            if (img.image_type === 'HEADER') {
              if (img.type === 'DEFAULT') {
                this.imageLibraryData.header.default.push(img)
              } else {
                this.imageLibraryData.header.uploaded.push(img)
              }
            } else {
              if (img.type === 'DEFAULT') {
                this.imageLibraryData.logo.default.push(img)
              } else {
                this.imageLibraryData.logo.uploaded.push(img)
              }
            }
          })
        })
        .catch(() => {
          flash('You are not authorized to view this resource.', 'is-danger')
        })
    },
    showTab (tabName) {
      this.selectedTab = tabName
    },
    selectImage (img) {
      this.selectedImage = img
    },
    useSelectedImage () {
      this.$emit('imageSelected', this.selectedImage)
    },
    deleteSelectedImage () {
      if (this.selectedImage && this.selectedImage.type === 'UPLOADED') {
        axios.delete(`/${this.businessSlug}/review/delete-uploaded-mail-images/${this.selectedImage.id}`)
          .then((response) => {
            this.getReviewInvitationMailImages()
          })
          .catch(() => {
            flash('You are not authorized to perform this action.', 'is-danger')
          })
      }
    },
    closeModal () {
      this.$emit('closeModal')
    },
    uploadImage (file) {
      this.csvError = ''
      this.uploading = true
      let formData = new FormData()
      formData.append('file', file)
      axios.post(`/${this.businessSlug}/review/upload-mail-images/${this.selectedTab}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(({data}) => {
          this.$refs.uploadField.removeAllFiles()
          this.$refs.uploadField.value = ''
          this.uploading = false
          this.getReviewInvitationMailImages()
        })
        .catch(error => {
          this.$refs.uploadField.value = ''
          this.uploading = false
          this.$emit('closeModal')
          if (error.response.data.message === 'Validation error') {
            if (this.selectedTab === 'headerImage') {
              flash('Upload a PNG or JPEG file. The minimum or expected size is 602 x 146 px. Max file size is 10 MB.', 'is-danger')
            } else {
              flash('Upload a PNG or JPEG file. The minimum or expected size is 211 x 54 px. Max file size is 10 MB.', 'is-danger')
            }
          } else {
            flash(error.response.data.message, 'is-danger')
          }
        })
    },
    errorHandle (file) {
      this.$refs.uploadField.removeAllFiles()
    },
    resetImageLib () {
      // eslint-disable-next-line standard/object-curly-even-spacing
      this.imageLibraryData = {'header': {'default': [], 'uploaded': []}, 'logo': {'default': [], 'uploaded': []}}
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/utilities/_colors.scss";

/** Modal CSS Starts */
.modal-card {
  max-width: 795px;
  width: 100%;
  height: 850px;
}

.modal-card-head {
  border-top: 10px solid color('blue-dark');
  padding-top: 0px;
  border-bottom: none !important;
  background-color: #fff;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.modal-card-head .cross-btn {
  font-size: 24px;
  position: absolute;
  top: 5px;
  right: 30px;
}

.modal-card-foot {
  border-top: none !important;
  background-color: #fff;
  border-radius: none !important;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  flex-direction: row-reverse;
}

.modal-card-foot .button:last-child {
  margin-right: 10px;
}

.modal-card-foot .dark-blue-btn {
  max-width: 130px;
  width: 100%;
  max-height: 35px;
}

.modal-card-foot .delete-btn {
  max-width: 130px;
  width: 100%;
  max-height: 35px;
}

.image-lib-row {
  margin-bottom: 20px;
}

.image-lib-row .no-img {
  font-size: 12px;
}

.image-lib-row h6 {
  font-size: 12px;
  line-height: 20px;
  font-weight: 600;
  color: #58595b;
}

.image-lib-row .horizontal-row {
  margin: 0 0 5px;
}

.image-lib-row .lib-images {
  margin: 15px 0;
}

.image-lib-row .lib-images .img-logo {
  width: 220px;
}

.image-lib-row .lib-images .img-header {
  width: 360px;
}

.image-lib-row .lib-images .img.selected {
  border: 2px solid color('blue');
}

.image-lib-row .lib-images .img {
  height: auto;
  display: inline-block;
  margin: 0 8px 16px 0;
  border: 2px solid transparent;
}

.image-lib-row .free-header-upload-row {
  color: #707070;
  font-size: 12px;
  text-align: center;
  margin: 32px 0;
}

.image-lib-row .free-header-upload-row a {
  text-decoration: underline;
  color: #30aae1;
}

.image-lib-row .free-header-upload-row a:hover {
  color: #30aae1;
}

.image-lib-row .free-header-upload-heading {
  color: #58595b;
  opacity: 0.5;
}

/** Modal CSS Ends */


/** Dropzone CSS Starts */
.image-lib-file-upload-section {
  width: 100%;
  position: relative;
  margin-top: 7px;
  margin-bottom: 11px;
}

.image-lib-file-upload-section .dropzone {
  min-height: 0px !important;
  border: solid 1px rgba(112, 112, 112, 0.3);
  background-color: rgba(243, 243, 243, 0.4);
}

.image-lib-file-upload-section .dropzone-custom-title {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
}

.image-lib-file-upload-section .free-image-upload {
  opacity: 0.4;
  background-color: rgb(243, 243, 243);
  font-size: 12px;
  padding: 20px 0;
  text-align: center;
}

.image-lib-file-upload-section .free-image-upload a {
  text-decoration: underline;
}

/** Dropzone CSS Ends */


/* Tabs CSS Begins */
.custom-tabs__tab-box {
  margin-bottom: 10px;
}

.tabs.is-boxed a.custom-tabs__link {
  border: 1px solid rgba(88, 89, 91, 0.32);
  width: 134px;
  height: 37px;
  padding: 0;
  margin-right: 5px;
  font-size: 14px;
  background: #fafafa;
  color: rgba(88, 89, 91, 0.6);
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

.tabs.is-boxed a.custom-tabs__link:hover {
  background-color: unset;
}

.tabs.is-boxed li.is-active a.custom-tabs__link {
  background-color: #fff;
  font-weight: bold;
  color: color('blue-dark');
}

.tabs.is-boxed a.custom-tabs__link .custom-tabs__text {
  opacity: 0.5;
}

.tabs.is-boxed .is-active a.custom-tabs__link .custom-tabs__text {
  opacity: 1;
}

/* Tabs CSS Ends */
</style>
<style>
/** DropZone Global CSS Starts **/
.image-lib-file-upload-section .dropzone .dz-message {
  margin: 0px !important;
}

.image-lib-file-upload-section .dropzone {
  border: 0 !important;
}

/** DropZone Global CSS Ends **/
</style>



// WEBPACK FOOTER //
// src/components/ImageLibraryModal.vue